export default __webpack_public_path__ + "static/media/RIW_A01.a18fa24c.mp4";